import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TemplateCatePageRoutingModule } from './template-cate-routing.module';

import { TemplateCatePage } from './template-cate.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TemplateCatePageRoutingModule
  ],
  declarations: [TemplateCatePage]
})
export class TemplateCatePageModule {}
